import { myAxios } from "./Helper";

// Fetch all booked dates from the API
export const fetchBookedDates = async () => {
    try {
        const response = await myAxios.get('/api/booking/booked-dates');
        return response.data;
    } catch (error) {
        console.error('Error fetching booked dates:', error);
        throw error;
    }
};

// Get user bookings
export const getUserBookings = async () => {
    try {
        const response = await myAxios.get('/api/booking/user-bookings');
        return response.data;
    } catch (error) {
        console.error('Error fetching user bookings:', error);
        throw error;
    }
};

// Get recent bookings for admin notifications
export const getRecentBookings = async (limit = 5) => {
    try {
        const response = await myAxios.get(`/api/booking/recent-bookings?limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching recent bookings:', error);
        throw error;
    }
}; 